import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import React, { useState, useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import { getAPICall } from "lib/callApi";
import { GET_PERMISSION_PROFILES } from "lib/constants";
import { enqueueSnackbar } from "notistack";
import Loader from "utils/Loader";
import EditPermission from "../EditPermission";
import AddPermissionsProfile from "../AddPermissionsProfile";

function RolePermission() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isEditPermissionDialogOpen, setIsEditPermissionDialogOpen] = useState(false);
  const [isAddPermissionsProfileDialogOpen, setIsAddPermissionsProfileDialogOpen] = useState(false);
  const [permissionProfileToEdit, setPermissionProfileToEdit] = useState();
  const [roles, setRoles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchRoles = async () => {
    try {
      setIsLoading(true);
      const response = await getAPICall(GET_PERMISSION_PROFILES, true);
      if (response?.data?.success) {
        setRoles(response.data.data);
      } else if (response.response.status !== 403) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text: "Something Went Wrong",
          }),
          {
            variant: "custom",
          }
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: "Something Went Wrong",
        }),
        {
          variant: "custom",
        }
      );
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - roles.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <MDBox sx={{ position: "relative" }}>
      <Loader loading={isLoading} />
      <MDBox p={3} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <MDTypography variant="h5">Permissions Profiles</MDTypography>
        <MDButton color="primaryRed" onClick={() => setIsAddPermissionsProfileDialogOpen(true)}>
          Add New Permissions Profile
        </MDButton>
      </MDBox>
      <MDBox component="form" pb={3} px={3}>
        <TableContainer
          component={Paper}
          sx={{
            boxShadow: "none",
            borderRadius: 0,
          }}
        >
          <Table
            aria-label="simple table"
            sx={{
              maxHeight: window.innerHeight < 800 ? 320 : 450,
              userSelect: "none",
            }}
          >
            <TableHead sx={{ display: "table-header-group" }}>
              <TableRow>
                <TableCell width="350px">Profile Name</TableCell>
                <TableCell align="center">Edit</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0
                ? roles.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : roles
              ).map((row) => (
                <TableRow key={row.id}>
                  <TableCell component="th" scope="row">
                    {row.profile_name}
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      sx={{ fontSize: "20px" }}
                      onClick={() => {
                        setIsEditPermissionDialogOpen(true);
                        setPermissionProfileToEdit(row);
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[10, 15, 20]}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            component="div"
            count={roles.length}
            rowsPerPage={rowsPerPage}
            page={page}
            sx={{ flex: "1 1 auto" }}
          />
        </TableContainer>
        <EditPermission
          open={isEditPermissionDialogOpen}
          setOpen={setIsEditPermissionDialogOpen}
          permissionProfileToEdit={permissionProfileToEdit}
        />
        <AddPermissionsProfile
          open={isAddPermissionsProfileDialogOpen}
          setOpen={setIsAddPermissionsProfileDialogOpen}
          fetchRoles={fetchRoles}
        />
      </MDBox>
    </MDBox>
  );
}

export default RolePermission;
